// extracted by mini-css-extract-plugin
export default {"title":"Ipn_SA7eztQx9P4KMjvM"};